<script>
    import PageComponentMixin from '../mixins/PageComponentMixin'

    const schema = {
        type: 'iframe',
        config: {
            "embedCode" : "<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/mlUjCWebXwY\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>"
        }
    }

    export default {
        name: 'Iframe',
        schema,
        mixins : [PageComponentMixin],
        data () {
            return {
            }
        },
        props: {
            originalTag: {
                type: String,
                default: ''
            }
        },
        render(h, context) {
            let {attributes, src, background} = this.$componentData

            let children = [ h('iframe', {
                attrs: attributes
            })]

            return h(this.originalTag)
        },
    }
</script>